import { useEffect } from 'react';

import environment from '../environment';

const { ADMINIFI_URL } = environment;
const ORG_BRANDING_STYLE_CLASS = '.org-branding-styles';

/**
 * Injects the Foundry organization's branding stylesheet into <head>.
 * No-op for the customer portal (cportal) and homeroom (orgData will be null).
 */
interface OrgData {
  id: string | number;
}

interface UseOrgBrandingParams {
  orgData: OrgData | undefined;
  portal: string;
}

export const useOrgBranding = ({ orgData, portal }: UseOrgBrandingParams): void => {
  useEffect(() => {
    if (portal === 'customer') return;

    if (!orgData?.id) return;

    const head = document.getElementsByTagName('head')?.item(0);
    if (!head) return;

    const prevTag = head.getElementsByClassName(ORG_BRANDING_STYLE_CLASS)?.item(0);
    if (prevTag) return;

    const cssTag = document.createElement('link');
    cssTag.href = `${ADMINIFI_URL}/brand_style_guides.css?organization_id=${orgData?.id}`;
    cssTag.type = 'text/css';
    cssTag.rel = 'stylesheet';
    cssTag.classList.add(ORG_BRANDING_STYLE_CLASS);

    head.appendChild(cssTag);
  }, [orgData, portal]);
};
